import { LazyLoad } from '@petconsole/pure-fe-mui';

const FoundPetAdmin = LazyLoad(() => import('./FoundPetAdmin'));

export { FoundPetAdmin };
